export default "__VITE_ASSET__BonBy_3___"